import * as React from 'react';
import InputErrorClass from './InputErrorClass';

export const Input = (props: any) => {
  const { type, label, name, errors, ...rest } = props;

  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      <input
        className={InputErrorClass({ errors, name })}
        name={name}
        type={type || 'text'}
        {...rest}
      />
      {errors[name] && <p className="invalid-feedback">{errors[name]}</p>}
    </div>
  );
}

export const InputAddon = (props: any) => {
  const { type, label, name, errors, onClick, ...rest } = props;

  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      <div className="input-group">
        <input
          className={InputErrorClass({ errors, name })}
          name={name}
          type={type || 'text'}
          {...rest}
        />
        <div className="input-group-append">
          <button
            className="btn btn-outline-secondary"
            type="button"
            onClick={onClick}
          >
            <i className="fa fa-download"></i>
          </button>
        </div>
      </div>
      {errors[name] && <p className="invalid-feedback">{errors[name]}</p>}
    </div>
  );
}

export const Textarea = (props: any) => {
  const { label, name, errors, ...rest } = props;

  return (
    <div className="form-group">
      {label && <label>{label}</label>}
      <textarea
        className={InputErrorClass({ errors, name })}
        name={name}
        {...rest}
      >
      </textarea>
      {errors[name] && <p className="invalid-feedback">{errors[name]}</p>}
    </div>
  );
}

export const Checkbox = (props: any) => {
  const { label, ...rest } = props;

  return (
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        {...rest}
      />
      <label className="form-check-label">
        {label}
      </label>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Shared/BsInput.tsx